//This file is automatically rebuilt by the Cesium build process.
export default "const float czm_oneOverTwoPi = 0.15915494309189535;\n\
";
